module.exports = __webpack_public_path__ + "static/img/land-img.da51d0a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/land-img.png
// module id = CHLs
// module chunks = 1